import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {CreateEditFormBase} from '../components/CreateEditFormBase'
import './CreateEdit.css';

import { withFirebase } from '../firebase';
import { AuthUserContext, withAuthorization } from '../session';


class ViewSona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sona: null,
    }
  }

  componentDidMount() {
    this.fetchSONA()
  }

  fetchSONA() {
    let sona_code = this.props.match.params.sona_code
    if (sona_code != null) {
      console.log(sona_code)
      this.props.firebase.sona_by_code(sona_code).once('value', results => {
        console.log(results.val())
        let sonas = results.val()
        let sona_ids = Object.keys(sonas)
        if (sona_ids.length > 0) {
          let sona = sonas[sona_ids[0]]
          this.setState({sona: sona})
        }
      })
    }
  }
  render() {
    let {sona} = this.state
    return (
      <AuthUserContext.Consumer>
        {(ctx) => {
          return (
            <div>
              <img
                className="Create-logo"
                src={process.env.PUBLIC_URL + '/img/logo.png'}
                alt="logo"
              />
              <h2>SONA: { sona != null ? sona.name : "--" }</h2>
              <p style={{fontSize: 16}}>
                <i>To view all the information linked to this SONA, download the SONAD app, for free, for iOS or Android.</i>
              </p>
              <p>
                <a href="https://play.google.com/store/apps/details?id=com.app.sonad.sonad"><img src={process.env.PUBLIC_URL + "/img/android_button.png"} /></a>&nbsp;
                <a href="https://apps.apple.com/us/app/yourapp/id1090538431"><img src={process.env.PUBLIC_URL + "/img/apple_button.png"} /></a>
              </p>
            </div>
          )
        }}
      </AuthUserContext.Consumer>
      )

  }
}


const condition = authUser => !!authUser;
export default withAuthorization(condition)(ViewSona);
